import { EntityManager } from "@/components/EntityManager";
import { StatusPill } from "@/components/StatusPill";
import { DRIVER_STATUS, CDL_CLASS } from "@/constants/options";

const money = (v) => (v == null || v === "" ? <span className="text-neutral-300">—</span> : `$${Number(v).toFixed(2)}/hr`);

export default function Drivers() {
  const columns = [
    { key: "driver_name", label: "Driver" },
    { key: "employee_id", label: "Emp ID" },
    { key: "phone", label: "Phone" },
    { key: "cdl_class", label: "CDL" },
    { key: "rate_per_hour", label: "Rate", align: "right", render: (r) => money(r.rate_per_hour) },
    { key: "driver_status", label: "Status", render: (r) => <StatusPill value={r.driver_status} /> },
    { key: "home_base", label: "Home Base" },
  ];
  const fields = [
    { label: "Driver Name", field: "driver_name" },
    { label: "Employee ID", field: "employee_id" },
    { label: "Phone", field: "phone" },
    { label: "Email", field: "email" },
    { label: "CDL Class", field: "cdl_class", type: "select", options: CDL_CLASS },
    { label: "Driver Status", field: "driver_status", type: "select", options: DRIVER_STATUS },
    { label: "Rate per Hour ($)", field: "rate_per_hour", type: "number" },
    { label: "Home Base", field: "home_base" },
    { label: "Notes", field: "notes", type: "textarea", span: 2 },
  ];
  return <EntityManager collection="drivers" title="Drivers" subtitle="Fleet driver roster, hourly rates & availability" columns={columns} fields={fields} />;
}
